module.exports = __webpack_public_path__ + "static/media/produceng.69e55638.png";